import { render, staticRenderFns } from "./SessionSingleHeader.vue?vue&type=template&id=21105ab5"
import script from "./SessionSingleHeader.vue?vue&type=script&lang=ts"
export * from "./SessionSingleHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports